import React, { ReactNode } from 'react'

import styles from './index.module.css'

interface IListProps {
  children: ReactNode
}

export default function List(props: IListProps) {
  const { children } = props

  const nextChildren = React.Children.map(children, child => <li>{child}</li>)

  return <ul className={styles.list}>{nextChildren}</ul>
}
